module.exports = __webpack_public_path__ + "img/fas_logo.0ec42df3.png";